import React from 'react';
import styles from '../brendangelo/brendangelo.module.scss';
import perfil from '../brendangelo/src/perfil.png';
import cuidadosPdf from './src/cuidados.pdf';

const cardImages = [
    {
        id: 1,
        image: require("./src/cards/1.png"),
        link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de agendar um horário em São José - Studio Kobrasol..."
    },
    // {
    //     id: 2,
    //     image: require("./src/cards/2.png"),
    //     link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de agendar um horário em Florianópolis - Studio Campeche"
    // },
    // {
    //     id: 3,
    //     image: require("./src/cards/3.png"),
    //     link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de agendar um horário contigo em Antonio Carlos…"
    // },
    {
        id: 4,
        image: require("./src/cards/4.png"),
        link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de fazer meu PRÉ agendamento para o INTERIOR DE SP..."
    },
    {
        id: 5,
        image: require("./src/cards/5.png"),
        link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de agendar um horário contigo de CABELO E MAQUIAGEM para eventos..."
    },
    {
        id: 6,
        image: require("./src/cards/6.png"),
        link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de participar do seu Curso de Auto Maquiagem..."
    },
    {
        id: 7,
        image: require("./src/cards/7.png"),
        link: "https://wa.me/554898131370?text=Oiii Brenda, tdo bem? Gostaria de saber mais sobre a Lobuloplastia não cirúrgica..."
    },
    {
        id: 8,
        image: require("./src/cards/8.png"),
        link: cuidadosPdf
    },
    {
        id: 8,
        image: require("./src/cards/9.png"),
        link: "#"
    },
];

const Brendangelo: React.FC = () => {
    return (
        <div className={styles.brendangelo}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card, index) => (
                        <a href={card.link} key={index} className={styles.card}>
                            <img src={card.image} alt={`Card ${card.id}`} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Brendangelo;
